module.exports = __webpack_public_path__ + "static/media/mulgrave-limerick.829317b0.png";